module.exports = __webpack_public_path__ + "assets/f296e462181f47b97cdfdedbc18ce933.png";